import React from 'react';
import { TBlockchain } from 'src/types';

interface TransactionHeaderProps {
  chain: TBlockchain;
}

const getChainLogo = (chain: TBlockchain) => {
  switch (chain) {
    case 'ethereum':
      return 'https://static.cdnlogo.com/logos/e/81/ethereum-eth.svg';
    case 'tron':
      return 'https://static.cdnlogo.com/logos/t/10/tron-trx.svg';
    case 'bitcoin':
      return 'https://static.cdnlogo.com/logos/b/10/bitcoin-btc.svg';
    default:
      return '';
  }
};

export const EVMTransactionHeader: React.FC<TransactionHeaderProps> = ({
  chain,
}) => {
  return (
    <div className="mb-8 flex items-center gap-4">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <img src={getChainLogo(chain)} alt={chain} className="h-8 w-8" />
      </div>
      <div>
        <h1 className="text-2xl font-bold capitalize">{chain} Transaction</h1>
        <p className="text-sm text-gray-500">View transaction details</p>
      </div>
    </div>
  );
};
